module.exports = __webpack_public_path__ + "static/media/home.0d4e3c32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home.svg
// module id = 2186
// module chunks = 0